import { render, staticRenderFns } from "./countRecord.vue?vue&type=template&id=4e848338&scoped=true&"
import script from "./countRecord.vue?vue&type=script&lang=js&"
export * from "./countRecord.vue?vue&type=script&lang=js&"
import style0 from "./countRecord.vue?vue&type=style&index=0&id=4e848338&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e848338",
  null
  
)

export default component.exports